import { FocusRing } from '@change/ds-core-ui';
import { CloseIcon, SearchIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { LocationResults } from './components/LocationResults';
import { useLocationFilter } from './hooks/useLocationFilter';
import { useTranslations } from './hooks/useTranslations';

export const LocationFilterMobile: React.FC = () => {
	const {
		data: {
			data: { isLoading, isError, locations },
			input: { inputRef, searchTerm },
		},
		actions: { handleInputFocus, handleInputChange, clearSearch, selectLocation },
	} = useLocationFilter();

	const {
		data: { placeholder, resetLabel },
	} = useTranslations();

	return (
		<div className="w-full">
			<form
				action=""
				onSubmit={(event) => {
					// This doesn't actually submit because the component's behaviour is search-as-you-type
					event.preventDefault();
					event.stopPropagation();
					inputRef.current?.blur();
				}}
				onReset={(event) => {
					event.preventDefault();
					event.stopPropagation();
					clearSearch();
				}}
			>
				<div className="relative w-full">
					<FocusRing>
						<input
							id="location-filter-input"
							name="location-filter-input"
							ref={inputRef}
							className="text-md disabled:text-typography-strong-disabled rounded-medium border-stroke-strong bg-fill-inverse-strong text-typography-strong placeholder-typography-disabled focus:outline-stroke-focus disabled:bg-fill-press h-11 w-full border border-solid px-12 py-1 focus:outline focus:outline-2 focus:outline-offset-2"
							placeholder={placeholder}
							value={searchTerm}
							onChange={(e) => {
								handleInputChange(e.target.value);
							}}
							onFocus={() => handleInputFocus()}
							type="search"
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							spellCheck={false}
							maxLength={512}
							data-testid="location-filter-input"
							data-qa="location-filter-input"
						/>
					</FocusRing>
					<SearchIcon className="text-icon-strong absolute top-0 left-0 z-10 h-full w-14 px-4" />
					{searchTerm && <ClearButton resetLabel={resetLabel} />}
				</div>
			</form>

			<LocationResults locations={locations} isLoading={isLoading} isError={isError} selectLocation={selectLocation} />
		</div>
	);
};

const ClearButton: React.FC<{ resetLabel: string }> = ({ resetLabel }) => (
	<div className="absolute top-0 right-0 bottom-0 flex h-11 flex-col justify-center px-1">
		<FocusRing>
			<button
				type="reset"
				aria-label={resetLabel}
				className="hover:text-typography-strong-hovered bg-fill-inverse-strong text-typography-strong hover:bg-fill-hover focus:bg-fill-hover focus:outline-stroke-focus flex h-10 w-10 items-center justify-center rounded-full focus:outline focus:outline-2 focus:outline-offset-2"
				data-testid="clear-search"
				data-qa="clear-search"
			>
				<CloseIcon aria-hidden="true" />
				<span className="sr-only">
					<Translate value="corgi.search.search_box.reset" />
				</span>
			</button>
		</FocusRing>
	</div>
);
